// Entry point. Importing "./ds" FIRST runs setup-globals (exposes window.React) and the vendored
// design-system bundle, so the facade's component exports are live before any screen renders.
import "./ds";
// Design tokens. The vendor token files are imported individually instead of the vendor
// styles.css entry: its fonts.css pulls webfonts from Google at runtime, and the redesign
// (#376) ships its own self-hosted faces below instead (DSGVO: no third-party requests).
import "./ds/vendor/tokens/colors.css";
import "./ds/vendor/tokens/typography.css";
import "./ds/vendor/tokens/spacing.css";
import "./ds/vendor/tokens/elevation.css";
// Shared self-hosted Inter artwork/font layer; IBM Plex Mono remains for technical references.
import "../../brand/brand.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
// Ribbon R aliases adapt the shared semantic themes to the retained DS vocabulary.
import "./styles/theme.css";
import "./styles/app.css"; // shared shell, inbox, and review foundations
import "./styles/admin.css"; // settings, rules, and administration
import "./styles/operator-shell.css"; // exact-parity shell, overview, inbox, workspace
import "./styles/detail-demo.css"; // detail screens and catalog
import "./styles/ribbon-components.css"; // shared component presentation; no screen composition

import "./styles/sidebar.css";
import "./styles/entry.css"; // public entry composition, after shared control presentation

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { SessionProvider } from "./session";
import { LiveUpdatesGate } from "./live/live-gate";
import { I18nProvider } from "./i18n";
import { RouterProvider } from "./router";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");
createRoot(rootEl).render(
  <I18nProvider>
    <SessionProvider>
      <LiveUpdatesGate>
        <RouterProvider>
          <App />
        </RouterProvider>
      </LiveUpdatesGate>
    </SessionProvider>
  </I18nProvider>,
);
